import React from 'react';
import PropTypes from 'prop-types';

import useDispatch from 'client/hooks/useDispatch';

import SrButton, { SR_BUTTON_THEME_ADOBE_GREY } from 'client/components/SrButton/SrButton';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrUtilityProfitAdminRegisterAddressForm from 'client/components/SrUtilityProfitAdminRegisterAddressForm/SrUtilityProfitAdminRegisterAddressForm';

import './SrUtilityProfitNewAddressModal.less';

const SrUtilityProfitNewAddressModal = ({
  onClose,
  afterSubmit,
  utilityPartnerId,
  utilityPartnerList,
}) => {
  const dispatch = useDispatch();

  return (
    <SrDarkModal style={{ padding: '30px' }}>
      <SrModalContent
        width="412px"
        innerStyle={{ padding: 0, width: '412px', boxShadow: '0px 15px 35px 0px #040F1D1A' }}
      >
        <div>
          <div styleName="header">
            <div styleName="headerBox">
              <span styleName="headerTitle">Add a new address</span>
            </div>
          </div>
          <div styleName="divider" />
          <div styleName="body">
            <SrUtilityProfitAdminRegisterAddressForm
              dispatch={dispatch}
              utilityPartnerId={utilityPartnerId}
              utilityPartnerList={utilityPartnerList}
              afterSubmit={afterSubmit}
            />
            <SrButton theme={SR_BUTTON_THEME_ADOBE_GREY} margin="8px 0px 0px" onClick={onClose}>
              Cancel
            </SrButton>
          </div>
        </div>
      </SrModalContent>
    </SrDarkModal>
  );
};

SrUtilityProfitNewAddressModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  afterSubmit: PropTypes.func,
  utilityPartnerId: PropTypes.number,
  utilityPartnerList: PropTypes.array,
};

SrUtilityProfitNewAddressModal.displayName = 'SrUtilityProfitNewAddressModal';

export default SrUtilityProfitNewAddressModal;
